import { createSlice } from "@reduxjs/toolkit";
import { API_LOAD_STATUS } from "constants/labels";
import { initialState } from "container/suplierDiversity/store/initialState";
import {
  getSupplierDiversityCategoryApi,
  getSupplierDiversityDetailsApi,
  getSupplierDiversityExpiringSupplierApi,
  getSupplierDiversityStateApi,
  getSupplierDiversitySummaryCountApi,
  postExpiringSupplierApi,
  postRegisteredSupplierFilterApi,
  postSupplierDiversityExpiringInApi,
  getAgencyApi,
  getBusinessCategoryApi,
  getClassificationApi,
  getDocumentTypeApi,
  getStateApi,
  registerSupplierDownloadApi,
} from "services/supplierDiversity/supplierDiversity.thunks";

const name = "supplierDiversity";

export const supplierDiversityPortalSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    const { PENDING, FULFILLED, REJECTED } = API_LOAD_STATUS;

    const addCaseGroup = (thunk, key) => {
      builder
        .addCase(thunk.pending, (state) => {
          state[key].Load.status = PENDING;
          state[key].Load.message = "";
          state[key].Load.errors = [];
          state[key].Succeeded = false;
          state[key].Data = null;
        })

        .addCase(thunk.fulfilled, (state, action) => {
          const {
            Data = null,
            Message = "",
            Succeeded = false,
          } = action.payload || {};
          state[key].Load.status = FULFILLED;
          state[key].Load.message = Message;
          state[key].Succeeded = Succeeded;
          state[key].Data = Data;
        })
        .addCase(thunk.rejected, (state, action) => {
          const { Message = "Error occurred", Errors = [] } =
            action.payload || {};
          state[key].Load.status = REJECTED;
          state[key].Load.message = Message;
          state[key].Load.errors = Errors;
          state[key].Succeeded = false;
          state[key].Data = null;
        });
    };

    // Register each thunk only once
    addCaseGroup(getSupplierDiversityDetailsApi, "supplierDiversityDetails");
    addCaseGroup(getSupplierDiversityCategoryApi, "supplierCategory");
    addCaseGroup(getSupplierDiversityStateApi, "supplierState");
    addCaseGroup(getSupplierDiversitySummaryCountApi, "supplierSummaryCount");
    addCaseGroup(getSupplierDiversityExpiringSupplierApi, "expiringSupplier");
    addCaseGroup(postSupplierDiversityExpiringInApi, "expiringInData");
    addCaseGroup(postRegisteredSupplierFilterApi, "resisterSupplier");
    addCaseGroup(postExpiringSupplierApi, "expiringFilterSupplier");
    addCaseGroup(getAgencyApi, "agency");
    addCaseGroup(getDocumentTypeApi, "documentType");
    addCaseGroup(getBusinessCategoryApi, "businessCategory");
    addCaseGroup(getClassificationApi, "classification");
    addCaseGroup(getStateApi, "state");
    addCaseGroup(registerSupplierDownloadApi, "registeredSupplierDownload");
  },
});

export default supplierDiversityPortalSlice.reducer;
